var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.57812 13.2372H8.05839V34.8487H1.57812V13.2372ZM33.9953 22.5858V34.8566H27.5166V23.0784C27.5166 20.663 26.8127 18.2476 23.9714 18.2476C22.6581 18.2556 21.3976 18.7654 20.448 19.6727C19.4985 20.58 18.9318 21.8161 18.8641 23.1276V34.8471H12.3664V13.1721H18.8641V16.1802C19.8124 14.9864 21.028 14.0322 22.4128 13.3946C23.7977 12.757 25.313 12.4538 26.8365 12.5094C29.9845 12.5094 34.0176 14.0683 34.0033 22.5873L33.9953 22.5858Z",
    fill: "#47358D"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4.73672,
    cy: 4.57265,
    r: 4.57265,
    fill: "#47358D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.5ed3bb25e7f0364bbd508873ffa28aca.svg";
export { ForwardRef as ReactComponent };